// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomPopover_button__2FVU4","popoverPosition":"CustomPopover_popoverPosition__3cYQm","circle":"CustomPopover_circle__EY7D0"};